import React from "react";
import cx from "clsx";

import globalStyles from "@/styles/global.module.scss";
import styles from "./button.module.scss";

class Button extends React.PureComponent {
  static defaultProps = {
    type: "button",
    disabled: false,
    pending: false
  };

  state = {
    buttonState: "idle",
    mouseHover: false,
    mouseDown: false
  };

  handleOnClick = event => {
    const { disabled, onClick } = this.props;

    event.stopPropagation();

    if (!disabled && onClick) onClick(event);
  };

  handleKeyPress = event => {
    const { disabled, onClick } = this.props;

    if (onClick) event.preventDefault();
    if (event.key !== "Enter" || disabled) return;

    if (onClick) onClick(event);
  };

  renderContent = () => {
    const {
      label,
      children,
      contentClassName,
      contentStyle,
      labelClassName,
      labelStyle,
      iconLeft,
      iconRight
    } = this.props;
    const { buttonState, mouseHover, mouseDown } = this.state;

    return (
      <div
        className={cx(styles.content, contentClassName)}
        style={contentStyle}
      >
        {iconLeft ? (
          typeof iconLeft === "function" ? (
            iconLeft({ buttonState, mouseHover, mouseDown })
          ) : (
            <span className={styles.iconLeft}>{iconLeft}</span>
          )
        ) : null}
        <span
          className={cx(globalStyles.text, styles.label, labelClassName)}
          style={labelStyle}
        >
          {label || children}
        </span>
        {iconRight ? (
          typeof iconRight === "function" ? (
            iconRight({ buttonState, mouseHover, mouseDown })
          ) : (
            <span className={styles.iconRight}>{iconRight}</span>
          )
        ) : null}
      </div>
    );
  };

  render() {
    const {
      type,
      pending,
      disabled,
      light,
      containerClassName,
      className,
      style,
      iconLeft,
      ...rest
    } = this.props;
    const { buttonState } = this.state;

    return (
      <div className={cx(styles.container, containerClassName)}>
        <button
          type={type}
          className={cx(
            globalStyles.buttonReset,
            styles.button,
            light && styles.light,
            (disabled || pending) && globalStyles.disabled,
            (disabled || pending) && styles.disabled,
            styles[buttonState],
            className
          )}
          style={style}
          onKeyPress={this.handleKeyPress}
          onClick={this.handleOnClick}
          disabled={disabled || pending}
          {...rest}
        >
          {this.renderContent()}
        </button>
      </div>
    );
  }
}

export default Button;
